import React, { Fragment, useEffect, useRef, useState } from "react";
import axios from "axios";
import JPlayer, {
  initializeOptions,
  Gui,
  SeekBar,
  BufferBar,
  Poster,
  Video,
  Title,
  FullScreen,
  Mute,
  Play,
  PlayBar,
  Repeat,
  VolumeBar,
  PlaybackRateBar,
  Duration,
  CurrentTime,
  BrowserUnsupported,
} from "react-jplayer";
import "../../../../App.css";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import Loader from "react-loader-spinner";
import Footer from "../../Footer";
import swal from "sweetalert";

import ClipLoader from "react-spinners/ClipLoader";
import { Link, useParams } from "react-router-dom";
import QRCode from "react-qr-code";

function AddStudio(props) {
  const [imgUrl, setImgUrl] = useState("");
  // Reload the page
  const [loading, setLoading] = useState(false);
  const [studioItemId, setStudioItemId] = useState(1);


  const [selectionType, setSelectionType] = useState("external"); // Internal or External
  const [showPopup, setShowPopup] = useState(false);
  const [url, setUrl] = useState("");


  const handleRadioChange = (e) => {
    setSelectionType(e.target.value);
    // if (e.target.value === "external") {
    //   setShowPopup(true);
    // } else {
    //   setShowPopup(false);
    // }
  };
  useEffect(() => {
    if (selectionType === "external") {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  }, [selectionType]);



  const [extProductThumbnail, setextProductThumbnail] = useState(null); // For the File object
  const [previewUrl, setPreviewUrl] = useState(null); // For previewing the image
  const [extProductName, setExtProductName] = useState("");
  const [extProductDescription, setExtProductDescription] = useState("");
  const [extProductPrice, setExtProductPrice] = useState("");
  const handleFieldChange = (field, value) => {
    if (field === "name") setExtProductName(value);
    if (field === "description") setExtProductDescription(value);
    if (field === "price") setExtProductPrice(value);
  };
  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      setPreviewUrl(URL.createObjectURL(file)); // Set the preview URL
      setextProductThumbnail(file); // Save the file object for upload
    } else {
      console.error("No file selected!");
    }
  };




  const [urlError, setUrlError] = useState("");
  const [BtnName, setBtnName] = useState("");



  const handleUrlChange = (e) => {
    const inputUrl = e.target.value;
    setUrl(inputUrl);

    // Relaxed URL validation
    const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*)?$/;
    if (inputUrl && !urlPattern.test(inputUrl)) {
      setUrlError("Please enter a valid URL.");
    } else {
      setUrlError(""); // Clear the error if valid
    }
  };


  const handleButtonNameChange = (e) => {
    const inputName = e.target.value;

    // Set the input value
    setBtnName(inputName);
  };
  const handlePopupClose = () => {
    setShowPopup(false);
  };







  const [data, setdata] = useState({
    "video-name": "",
    "video-url": "",
    Product_Id: "",
    "thumbnail-img": "",
    "current-video-time": "",
    "selected-duration": "",
    "Video-Duration": "0",
    "Product-name": "",
    Qr_url: "",
    "Product-Price": "",
    "Button-clicked": "",
    "Added-Url": "",
    Studio_Id: "",
  });

  // console.log("data+++++", data)
  const [videos, setVideos] = useState(undefined);
  const [HitUseEffect, setHitUseEffect] = useState(false);
  const [selectedDuration, setselectedDuration] = useState("15");
  const [currentTime, setcurrentTime] = useState(0);
  const [resData, setresData] = useState();
  const [adData, setAdData] = useState();
  let addProdRef = useRef();
  let addpopupWindow = useRef();
  let addpopupWindowAdVideo = useRef();
  let addpopupForShowWindow = useRef();
  let addpopupForShowScanBuy = useRef();
  let thumbnailParent = useRef();
  let thumbnailParentForScan = useRef();
  let thumbnailParentForProduct = useRef();
  let QrCodeRef = useRef();
  let shopNowRef = useRef();
  let adVideoRef = useRef();
  let viewMoreRef = useRef();
  const [productdata, setproductdata] = useState([]);
  const { token } = isAutheticated();
  const { id } = useParams();
  const [success, setSuccess] = useState(false);
  const [studioDataLoading, setStudioDataLoading] = useState(false);
  const [AddvideoDuration, setAddVideoDuration] = useState(0); // State to store video duration
  const [currentEditItem, setCurrentEditItem] = useState(null);


  const handleLoadedMetadata = (event) => {
    const duration = event.target.duration; // Get video duration
    setAddVideoDuration(Math.floor(duration));
  };
  const defaultOptions = {
    id: "VideoPlayer",
    keyEnabled: true,
    verticalVolume: true,
    media: {
      sources: {
        // m4v: videos?.video?.slice(0, 5) === 'https' ? videos?.video : `https://${videos?.video}`,
        m4v: videos?.video,
      },
    },
  };
  if (videos?.video) {

    initializeOptions(defaultOptions);


  }








  useEffect(() => {
    const fetchData = () => {
      axios
        .get(`${API}/api/adlesson/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          console.log(response);
          setAdData([...response.data.data]);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchData();
  }, [success, token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch video lesson data
        const lessonResponse = await axios.get(`${API}/api/lesson/video/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (lessonResponse.data) {
          // Update state with video data
          setVideos(lessonResponse.data);

          // Save studioId to localStorage
          const studioId = lessonResponse.data.studio_id;
          localStorage.setItem("studioId", studioId);

          // Update state with video URL and studio ID
          setdata((prev) => ({
            ...prev,
            "video-url": lessonResponse.data.video.toString(),
            Studio_Id: studioId,
          }));
        }
        // Fetch product data
        const productResponse = await axios.get(`${API}/api/product`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Product Data:", productResponse.data);

        // Update state with product data
        setproductdata(productResponse.data.data || []);


      } catch (error) {
        console.error("Error fetching data:", error);
        // Optionally, set error state or display a user-friendly message
      }
    };

    // Call fetchData when dependencies change
    fetchData();

    // Cleanup function on component unmount or dependency change
    return () => {
      setdata({});
      setVideos({});
    };
  }, [success, id, token]);

  useEffect(() => {
    const fetchVideo = async () => {
      try {
        const response = await axios.get(`${API}/api/lesson/video/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data) {
          setVideos(response.data);
        }
      } catch (error) {
        console.error("Error fetching video data:", error);
      }
    };

    fetchVideo();
  }, [id, token]);
  // Dependencies: Update when `success`, `id`, or `token` changes

  // const VideoClickhandle = (e) => {
  //     if (addProdRef.current.style.display === "inline-block") {
  //         addProdRef.current.style.display = "none";
  //     } else {
  //         addProdRef.current.style.display = "inline-block";
  //     }
  //     if (shopNowRef.current.style.display === "inline-block") {
  //         shopNowRef.current.style.display = "none";
  //     } else {
  //         shopNowRef.current.style.display = "inline-block";
  //     }
  //     if (viewMoreRef.current.style.display === "inline-block") {
  //         viewMoreRef.current.style.display = "none";
  //     } else {
  //         viewMoreRef.current.style.display = "inline-block";
  //     }
  //     if (QrCodeRef.current.style.display === "inline-block") {
  //         QrCodeRef.current.style.display = "none";
  //     } else {
  //         QrCodeRef.current.style.display = "inline-block";
  //     }

  //     let str = document.getElementsByClassName("jp-media").item(0).currentTime;
  //     setcurrentTime(Math.floor(str));
  //     setdata(
  //         {
  //             ...data,
  //             "thumbnail-img": e.target.src,
  //             "current-video-time": currentTime,
  //             "Video-Duration": Math.floor(document.getElementsByClassName("jp-media").item(0).duration),
  //         })
  // }


  useEffect(() => {
    // Hide all popup windows on initial load
    if (addpopupWindow?.current) addpopupWindow.current.style.display = "none";
    if (addpopupForShowWindow?.current) addpopupForShowWindow.current.style.display = "none";
    if (addpopupForShowScanBuy?.current) addpopupForShowScanBuy.current.style.display = "none";
    if (addpopupWindowAdVideo?.current) addpopupWindowAdVideo.current.style.display = "none";
  }, []); // runs once on mount













  const handleClosePopup = (e) => {
    setCurrentEditItem(null);

    // Then, hide all popup windows safely
    setTimeout(() => {
      addpopupWindow?.current && (addpopupWindow.current.style.display = "none");
      addpopupForShowWindow?.current && (addpopupForShowWindow.current.style.display = "none");
      addpopupForShowScanBuy?.current && (addpopupForShowScanBuy.current.style.display = "none");
      addpopupWindowAdVideo?.current && (addpopupWindowAdVideo.current.style.display = "none");
    }, 0); // Runs immediately but allows state to update first

  };




  const selectImagehandler = (e) => {
    if (e.target.className === "active") {
      e.target.classList.remove("active");
      for (let i = 0; i < thumbnailParent.current.childNodes.length; i++) {
        thumbnailParent.current.childNodes[i].childNodes[0].classList.remove(
          "active"
        );
        if (
          thumbnailParent.current.childNodes[i].childNodes[0].src ===
          e.target.src
        ) {
          setdata({
            ...data,
            "Product-name": "",
            "Product-Price": "",
            Product_Id: "",
            "current-video-time": currentTime,
            "thumbnail-img": "",
          });
        }
      }
    } else {
      for (let i = 0; i < thumbnailParent.current.childNodes.length; i++) {
        thumbnailParent.current.childNodes[i].childNodes[0].classList.remove(
          "active"
        );
        if (
          thumbnailParent.current.childNodes[i].childNodes[0].id === e.target.id
        ) {
          setdata({
            ...data,
            "Product-name":
              thumbnailParent.current.childNodes[i].childNodes[1].innerText,
            "Product-Price":
              thumbnailParent.current.childNodes[i].childNodes[2].innerText,
            Product_Id:
              thumbnailParent.current.childNodes[i].childNodes[3].innerText,
            "thumbnail-img": e.target.src,
            "current-video-time": currentTime,
          });
        }
      }
      e.target.classList.add("active");
    }
  };
  // const selectImagehandlerForProduct = (e) => {
  //   const target = e.target;
  //   const { src, id, className } = target;

  //   if (className.includes("active")) {
  //     // Deselect the active thumbnail
  //     setdata((prevData) => ({
  //       ...prevData,
  //       "Product-name": "",
  //       "Product-Price": "",
  //       Product_Id: "",
  //       "current-video-time": currentTime,
  //       "thumbnail-img": "",
  //     }));
  //     target.classList.remove("active");
  //   } else {
  //     // Deselect all thumbnails
  //     const allThumbnails = Array.from(thumbnailParentForProduct.current.childNodes);
  //     allThumbnails.forEach((child) => {
  //       child.childNodes[0].classList.remove("active");
  //     });

  //     // Select the clicked thumbnail
  //     const selectedThumbnail = allThumbnails.find(
  //       (child) => child.childNodes[0].id === id
  //     );

  //     if (selectedThumbnail) {
  //       const productName = selectedThumbnail.childNodes[1].innerText;
  //       const productPrice = selectedThumbnail.childNodes[2].innerText;
  //       console.log("ffffffffffff", id)
  //       const productId = id;

  //       setdata((prevData) => ({
  //         ...prevData,
  //         "Product-name": productName,
  //         "Product-Price": productPrice,
  //         Product_Id: productId,
  //         "thumbnail-img": src,
  //         "current-video-time": currentTime,
  //       }));

  //       target.classList.add("active");
  //     }
  //   }
  // };
  const selectImagehandlerForProduct = (e) => {
    const target = e.target.closest(".spanForImg"); // Ensure correct target

    if (!target) return; // Exit if the click wasn't on a valid thumbnail

    const imgElement = target.querySelector("img");
    const { id, dataset } = imgElement;

    if (imgElement.classList.contains("active")) {
      // Deselect the active thumbnail
      setdata((prevData) => ({
        ...prevData,
        "Product-name": "",
        "Product-Price": "",
        Product_Id: "",
        "current-video-time": currentTime,
        "thumbnail-img": "",
      }));
      imgElement.classList.remove("active");
    } else {
      // Deselect all thumbnails
      const allThumbnails = Array.from(thumbnailParentForProduct.current.querySelectorAll(".thumbnail-img"));
      allThumbnails.forEach((thumb) => thumb.classList.remove("active"));

      // Select the clicked thumbnail and update state
      setdata((prevData) => ({
        ...prevData,
        "Product-name": dataset.title,
        "Product-Price": dataset.price,
        Product_Id: id,
        "thumbnail-img": imgElement.src,
        "current-video-time": currentTime,
      }));

      imgElement.classList.add("active"); // Mark as active
    }
  };


  console.log("dddddddddddddddddd", data)
  const selectImagehandlerForAdVideo = (e, item) => {
    const thumbnails = thumbnailParentForProduct.current.childNodes;

    // Check if the clicked thumbnail is already active
    if (e.target.classList.contains("active")) {
      // Unselect the active thumbnail
      e.target.classList.remove("active");

      // Reset the data to clear the selection
      setdata({
        ...data,
        "Product-name": "",
        "Product-Price": "",
        "current_time": "",
        "CTA": "",
        "selected-duration": "",
        Product_Id: "",
        "Video-Duration": "",
        "current-video-time": currentTime,
        "thumbnail-img": "",
      });
    } else {
      // Unselect all thumbnails
      thumbnails.forEach((thumbnail) => {
        thumbnail.childNodes[0].classList.remove("active");
      });

      // Mark the clicked thumbnail as active
      e.target.classList.add("active");

      // Update the data with the selected product details
      setdata({
        ...data,
        "Added-Url": item.video,
        "Product-name": item.title,
        "Product-Price": item.price || "",
        Product_Id: item._id,
        "thumbnail-img": item.thumbnail,
        "current-video-time": currentTime,
      });
    }
  };


  const selectImagehandlerForScan = (e) => {
    if (e.target.className === "active") {
      e.target.classList.remove("active");
      for (
        let i = 0;
        i < thumbnailParentForScan.current.childNodes.length;
        i++
      ) {
        thumbnailParentForScan.current.childNodes[
          i
        ].childNodes[0].classList.remove("active");
        if (
          thumbnailParentForScan.current.childNodes[i].childNodes[0].src ===
          e.target.src
        ) {
          setdata({
            ...data,
            "Product-name": "",
            "Product-Price": "",
            Product_Id: "",
            "current-video-time": currentTime,
            "thumbnail-img": "",
          });
        }
      }
    } else {
      for (
        let i = 0;
        i < thumbnailParentForScan.current.childNodes.length;
        i++
      ) {
        thumbnailParentForScan.current.childNodes[
          i
        ].childNodes[0].classList.remove("active");
        if (
          thumbnailParentForScan.current.childNodes[i].childNodes[0].id ===
          e.target.id
        ) {
          setdata({
            ...data,
            "Product-name":
              thumbnailParentForScan.current.childNodes[i].childNodes[1]
                .innerText,
            "Product-Price":
              thumbnailParentForScan.current.childNodes[i].childNodes[2]
                .innerText,
            Product_Id:
              thumbnailParentForScan.current.childNodes[i].childNodes[3]
                .innerText,
            "thumbnail-img": e.target.src,
            "current-video-time": currentTime,
          });
        }
      }
      e.target.classList.add("active");
    }
  };
  // const selectOptionHandler = (e) => {
  //   if (e.target.value.toLowerCase() === "throughout") {
  //     durationInSeconds = videoDuration; // Use the total video duration
  //   }
  //   const value = e.target.value;
  //   setselectedDuration(value);

  //   // Convert value to seconds for storing in data
  //   const durationInSeconds =
  //     value.includes("minute") ? Number(value.split(" ")[0]) * 60 : Number(value);

  //   setdata({
  //     ...data,
  //     "selected-duration": durationInSeconds,
  //     "current-video-time": currentTime,
  //   });
  // };


  const selectOptionHandler = (e) => {
    const value = e.target.value.toLowerCase(); // Get the selected value
    let durationInSeconds = null;

    if (value === "throughout") {
      durationInSeconds = "throughout"; // Set as "throughout" instead of seconds
      setselectedDuration("Throughout"); // Display "Throughout" in the UI
    } else if (value.includes("minute")) {
      durationInSeconds = Number(value.split(" ")[0]) * 60; // Convert minutes to seconds
      setselectedDuration(value); // Set the selected duration from the dropdown
    } else {
      durationInSeconds = Number(value); // Assume the value is in seconds
      setselectedDuration(value); // Set the selected duration from the dropdown
    }
    //

    if (currentEditItem?.id) {
      setCurrentEditItem({
        ...currentEditItem,
        duration: durationInSeconds,
      });
    }
    // Update state with the selected duration and current video time
    setdata({
      ...data,
      "selected-duration": durationInSeconds,
      "current-video-time": currentTime,
    });
  };



  // const selectOptionHandler = (e) => {
  //   const value = e.target.value;
  //   setselectedDuration(value);

  //   // Convert value to seconds for storing in data
  //   let durationInSeconds;
  //   if (value === "Throughout") {
  //     durationInSeconds = "Throughout";
  //   } else if (value.includes("minute")) {
  //     durationInSeconds = Number(value.split(" ")[0]) * 60;
  //   } else {
  //     durationInSeconds = Number(value);
  //   }

  //   setdata((prev) => ({
  //     ...prev,
  //     "selected-duration": durationInSeconds,
  //     "current-video-time": currentTime,
  //   }));
  //   // If editing, also update currentEditItem's duration
  //   if (currentEditItem?.id) {
  //     setCurrentEditItem({
  //       ...currentEditItem,
  //       duration: durationInSeconds,
  //     });
  //   }
  // };
  console.log('fffffffff', data)












  const handlePlayClick = (e) => {
    if (e.target.className === "fa fa-play") {
      e.target.classList.remove("fa-play");
      e.target.classList.add("fa-pause");
    } else {
      e.target.classList.remove("fa-pause");
      e.target.classList.add("fa-play");
    }
  };
  const handleAddproduct = async (item) => {
    console.log("item", item);

    // Extract current time and video duration
    const currentTime = Math.floor(
      item?.current_time || document.getElementsByClassName("jp-media").item(0)?.currentTime || 0
    );
    const videoDuration = Math.floor(
      document.getElementsByClassName("jp-media").item(0)?.duration || 0
    );

    // Update state for currentTime and data
    await setcurrentTime(currentTime);
    await setdata({
      ...data,
      "Button-clicked": "Shop on device",
      "current-video-time": currentTime,
      "Video-Duration": videoDuration,
    });

    // Update currentEditItem with the latest values
    const updatedCurrentEditItem = {
      ...item,
      currentTime,
      videoDuration,
    };
    await setCurrentEditItem(updatedCurrentEditItem);


    // Proceed if the item's type is 'external'
    if (updatedCurrentEditItem?.type === "external") {
      setBtnName(updatedCurrentEditItem?.show_Button_Name || "")
      setUrl(updatedCurrentEditItem?.extProduct_url || "");
      setPreviewUrl(updatedCurrentEditItem?.extProductThumbnail_Url || "");
      setExtProductName(updatedCurrentEditItem?.extProduct_Name || "");
      setExtProductDescription(updatedCurrentEditItem?.extProduct_Description || "");
      setExtProductPrice(updatedCurrentEditItem?.extProduct_Price || "");
    }

    // Show the popup
    if (addpopupWindow.current) {
      addpopupWindow.current.style.display = "flex";
    }
  };

  const handleShop = async (e) => {
    let str = document.getElementsByClassName("jp-media").item(0)?.currentTime;
    await setcurrentTime(Math.floor(str));
    await setdata({
      ...data,
      "Button-clicked": "Shop on website",
      "current-video-time": Math.floor(str),
      "Video-Duration": Math.floor(
        document.getElementsByClassName("jp-media").item(0)?.duration
      ),
    });
    addpopupForShowWindow.current.style.display = "flex";
  };
  const handleAdVideo = async (e) => {
    let str = document.getElementsByClassName("jp-media").item(0)?.currentTime;
    await setcurrentTime(Math.floor(str));
    await setdata({
      ...data,
      "Button-clicked": "Insert Ad Video",
      "current-video-time": Math.floor(str),
      "Video-Duration": Math.floor(
        document.getElementsByClassName("jp-media").item(0)?.duration
      ),
    });
    addpopupWindowAdVideo.current.style.display = "flex";
  };
  const handleViewMore = async (e) => {
    let str = document.getElementsByClassName("jp-media").item(0)?.currentTime;
    console.log(str);
    await setcurrentTime(Math.floor(str));
    await setdata({
      ...data,
      "Button-clicked": "Scan to Buy",
      "current-video-time": Math.floor(str),
      "Video-Duration": Math.floor(
        document.getElementsByClassName("jp-media").item(0)?.duration
      ),
    });
    addpopupForShowScanBuy.current.style.display = "flex";
  };
  const handleQrCode = (e) => {
    console.log(e);
  };
  const handleInputChange = (e) => {
    setdata({
      ...data,
      "Added-Url": e.target.value,
    });
  };
  const handleInputChangeForQrCode = (e) => {
    setdata({
      ...data,
      Qr_url: e.target.value,
    });
  };
  const handleSubmitShopData = () => {
    setLoading(true);
    axios
      .post(
        `${API}/api/studio/add_product_list/${data["Studio_Id"]}`,
        {
          id: studioItemId,
          duration: data["selected-duration"],
          current_time: data["current-video-time"],
          url: data["Added-Url"],
          product: data["Product_Id"],
          videoId: props.match.params.id,
          CTA: data["Button-clicked"],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        setresData(res.data);
        setLoading(false);
        addpopupForShowWindow.current.style.display = "none";
        window.location.reload();
      })
      .catch((error) => {
        alert("Adding Failed");
        setLoading(false);
        console.log(error);
      });
    // setresData(res.data);
    // setLoading(false);
    // addpopupForShowWindow.current.style.display = "none";
  };
  const handleProductSubmit = () => {
    setLoading(true);

    // Validation for external products
    if (selectionType === "external") {
      if (!url || urlError) {
        setLoading(false);
        alert("Please provide a valid URL for the eCommerce product.");
        return;
      }
      if (!extProductName) {
        setLoading(false);
        alert("Please provide eCommerce Product Name");
        return;
      }
      if (!BtnName) {
        setLoading(false);
        alert("Please provide Button Name you want to show on the website");
        return;
      }

      if (!extProductThumbnail) {
        setLoading(false);
        alert("Please upload a thumbnail for the eCommerce product.");
        return;
      }
    } else {
      // Validation for internal products
      if (!data["Product_Id"]) {
        setLoading(false);
        alert("Please select a product for the Shop on OTT Product");
        return;
      }
    }

    const formData = new FormData();

    formData.append("id", studioItemId);
    formData.append("type", selectionType || "internal");
    formData.append("duration",
      //  currentEditItem?.duration ?? selectedDuration
      data["selected-duration"] || selectedDuration
    );
    // formData.append("current_time", data["current-video-time"]);
    formData.append("current_time", data["current-video-time"] === 0 ? 1 : data["current-video-time"]);

    formData.append("CTA", data["Button-clicked"] || "Shop on device");
    formData.append("show_Button_Name", BtnName);

    formData.append("videoId", props.match.params.id);
    formData.append("Studio_Id", data["Studio_Id"]);

    if (selectionType === "external") {
      formData.append("extProduct_url", url);
      formData.append("extProduct_Name", extProductName);

      formData.append("extProduct_Description", extProductDescription);

      formData.append("extProduct_Price", extProductPrice);

      if (extProductThumbnail instanceof File) {
        formData.append("file", extProductThumbnail); // Ensure thumbnail is a valid File object
      } else {
        console.error("Thumbnail is not a valid file!");
      }
    } else {
      formData.append("product", data["Product_Id"]);
    }

    axios
      .post(`${API}/api/studio/add_product_list/${data["Studio_Id"]}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res.data);
        setresData(res.data);
        setCurrentEditItem(null)

        setLoading(false);
        setSuccess(!success)
        handleClosePopup(); // Close the popup
        // addpopupWindow.current.style.display = "none";
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        alert(error?.response?.data?.message);

        console.error(error);
      });
  };
  //handle Edit Current Ad product
  const handleProductEdit = () => {
    setLoading(true);

    // console.log("currentEditItem", currentEditItem)
    // console.log("currentEditItemId", currentEditItem?.id)

    // Validation for external products
    if (currentEditItem?.type === "external") {
      if (!url || urlError) {
        setLoading(false);
        alert("Please provide a valid URL for the eCommerce product.");
        return;
      }
      if (!extProductName) {
        setLoading(false);
        alert("Please provide eCommerce Product Name");
        return;
      }
      if (!BtnName) {
        setLoading(false);
        alert("Please provide Button Name you want to show on the website");
        return;
      }

      if (!previewUrl) {
        setLoading(false);
        alert("Please please Upload a image");
        return;
      }
    } else {
      // Validation for internal products
      if (!data["Product_Id"]) {
        setLoading(false);
        alert("Please select a product for the Shop on OTT Product");
        return;
      }
    }
    const currentTime = Number(currentEditItem?.current_time) // Convert to a number
    console.log("currentTime", currentTime)

    const formData = new FormData();

    formData.append("id", studioItemId);
    formData.append("type", currentEditItem?.type || "internal");
    // formData.append("duration", data["selected-duration"] || selectedDuration);
    let durationToSend;
    if (
      data["selected-duration"] === "" ||
      data["selected-duration"] === undefined ||
      data["selected-duration"] === null
    ) {
      durationToSend = currentEditItem?.duration ?? selectedDuration;
    } else {
      durationToSend = data["selected-duration"];
    }
    formData.append("duration", durationToSend);

    formData.append(
      "current_time",
      isNaN(currentTime) ? "10" : currentTime.toString()
    ); formData.append("CTA", data["Button-clicked"] || "Shop on device");
    formData.append("show_Button_Name", BtnName);

    formData.append("videoId", props.match.params.id);
    formData.append("Studio_Id", data["Studio_Id"]);

    if (currentEditItem?.type === "external") {
      formData.append("extProduct_url", url);
      formData.append("extProduct_Name", extProductName);
      formData.append("extProduct_Description", extProductDescription);
      formData.append("extProduct_Price", extProductPrice);

      if (extProductThumbnail instanceof File) {
        formData.append("file", extProductThumbnail); // Upload new thumbnail
      } else {
        formData.append("extProductThumbnail_Url", currentEditItem.extProductThumbnail_Url); // Retain old thumbnail URL
        formData.append("extProductThumbnail_PublicId", currentEditItem.extProductThumbnail_PublicId); // Retain old Public ID
      }


    } else {
      formData.append("product", data["Product_Id"]);
    }

    axios
      .patch(`${API}/api/studio/${data["Studio_Id"]}/product/${currentEditItem?.id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res.data);
        setresData(res.data);
        setCurrentEditItem(null)
        setLoading(false);
        setSuccess(!success)
        handleClosePopup(); // Close the popup
        // addpopupWindow.current.style.display = "none";
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error)
        alert(error?.response?.data?.message);

        console.error(error);
      });
  };







  const handleAdVideoSubmit = async () => {
    setLoading(true);
    console.log(studioId, "Submitting data:", data);
    const currentTime = Number(data["current-video-time"] || 0);
    if (currentTime <= 0) {
      setLoading(false);
      alert("The Ad video time must be greater than zero seconds. Please update it.");
      return;
    }

    const mandatoryFields = [
      { field: data["Studio_Id"], name: "Studio ID" },
      { field: studioItemId, name: "Studio Item ID" },
      { field: data["Added-Url"], name: "Add Video" },

      // { field: data["selected-duration"], name: "Select Duration" },

      { field: data["Product_Id"], name: "Select Ad Vedeo" },
      { field: data["Button-clicked"], name: "CTA Button" },
      { field: props.match.params.id, name: "Video ID" },
    ];

    const missingFields = mandatoryFields.filter((item) => !item.field);

    if (missingFields.length > 0) {
      setLoading(false);
      alert(
        `Missing mandatory fields: ${missingFields
          .map((item) => item.name)
          .join(", ")}`
      );
      return;
    }


    try {
      const response = await axios.post(
        `${API}/api/studio/add_product_list/${data["Studio_Id"]}`,
        {
          id: String(studioItemId),
          url: data["Added-Url"],
          type: "video",
          duration: data["selected-duration"] || "",
          current_time: Number(data["current-video-time"]),
          AdVideo: data["Product_Id"],
          videoId: props.match.params.id,
          CTA: data["Button-clicked"],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Response:", response.data);
      setresData(response.data);
      setLoading(false);
      setSuccess(!success);
      handleClosePopup();
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.data) {
        alert(`Adding Failed: ${error.response.data.message}`);
      } else {
        alert("Adding Failed: Network or Server Error");
      }
      console.error("Error:", error);
    }
  };

  const handleSubmitScanToBuy = () => {
    setLoading(true);
    console.log(data);
    const svg = document.getElementById("QRCode");
    const svgData = new XMLSerializer().serializeToString(svg);
    const img = new Image();
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
    const API_ENDPOINT =
      "https://api.cloudinary.com/v1_1/deaxaoxfk/image/upload";
    const formData = new FormData();
    formData.append("file", img.src);
    formData.append("upload_preset", "ml_default"); // upload preset
    fetch(API_ENDPOINT, {
      method: "post",
      body: formData,
    })
      .then((response) => response.json())
      .then((item) => {
        axios
          .post(
            `${API}/api/studio/add_product_list/${data["Studio_Id"]}`,
            {
              id: studioItemId,
              duration: data["selected-duration"],
              current_time: data["current-video-time"],
              product: data["Product_Id"],
              qr_code: item.secure_url,
              videoId: props.match.params.id,
              CTA: data["Button-clicked"],
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((res) => {
            setresData(res.data);
            setLoading(false);
            addpopupForShowScanBuy.current.style.display = "none";
            window.location.reload();
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
          });
      })
      .catch((err) => {
        addpopupForShowScanBuy.current.style.display = "none";
        console.error("Error:", err);
      });
  };
  let studioId = localStorage.getItem("studioId");


  const handleDelete = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {

        console.log("Studio_Id", studioId)
        console.log("if", id)

        try {
          const res = await axios.delete(
            `${API}/api/studio/delete_product/${data["Studio_Id"]}?id=${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          console.log(res.data.studio);
          setresData(res.data.studio);

          swal("Poof! Your product has been deleted!", {
            icon: "success",
          });
        } catch (error) {
          console.error("Error deleting product:", error);
          swal("Error!", "Something went wrong while deleting the product.", "error");
        }
      } else {
        swal("Your product is safe!");
      }
    });
  };



  useEffect(() => {
    const fetchData = async () => {
      setStudioDataLoading(true);

      try {
        const res = await axios.get(`${API}/api/studio/view_byid/${studioId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log("Fetched Data:", res);

        // Determine next studio item ID
        if (res.data?.items?.length > 0) {
          const lastId = parseInt(res.data.items[res.data.items.length - 1]?.id, 10);
          const nextId = isNaN(lastId) ? 1 : lastId + 1;

          console.log("Last ID:", lastId, "Next ID:", nextId);
          setStudioItemId(nextId);
        } else {
          setStudioItemId(1); // Default to 1 if no items exist
        }

        setresData(res.data);
      } catch (err) {
        console.error("Error fetching studio data:", err);
      } finally {
        setStudioDataLoading(false);
      }
    };

    fetchData();

    return () => {
      setresData(null); // Cleanup on unmount
    };
  }, [success, studioId, token]);


  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Content Management - Studio</h4>
                {/* {console.log(subjects)} */}
                {/* {console.log(languages)} */}
                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>
                      Content Management - Studio
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className='row' >
            <div className='col-lg-12'>
              <div className='' >
                <div className=''>
                  {/* <div className="row ml-0 mr-0  mb-10">
                                        <div className="col-sm-12 col-md-6">&nbsp;</div>

                                    </div>
                                    <div className="table-responsive table-shoot">

                                    </div> */}
                  <div className='VideoContainer' style={{
                    width: "100%",
                    minHeight: "100vh",  // Ensures full-page height
                    maxHeight: "none",   // No height restriction
                    overflowY: "auto",   // Enables vertical scrolling
                    padding: "20px",
                    boxSizing: "border-box"
                  }}>
                    <div style={{ display: "none", margin: "20px" }}>
                      {data["Qr_url"] && (
                        <QRCode
                          id='QRCode'
                          bgColor='#ffffff'
                          level='L'
                          value={data["Qr_url"]}
                        />
                      )}
                    </div>
                    <div ref={addpopupWindowAdVideo} className='addpopupWindow'>
                      <span onClick={handleClosePopup} id='closeBtn'>
                        X
                      </span>
                      {/* <span id='headContent'>
                        <p>
                          <h5 style={{ marginLeft: "5px", color: "#0f0431" }}><b style={{ fontSize: "25px", color: "#3d1f98" }}>Step1</b>: How long do you want Advideo to be visible on the Screen?</h5>
                          <span>

                            <h6>Select duration</h6>
                            <select value={selectedDuration} onChange={selectOptionHandler} className="select">
                              <option value="5">5 seconds</option>
                              <option value="10">10 seconds</option>
                              <option value="15">15 seconds</option>
                              <option value="20">20 seconds</option>
                              <option value="25">25 seconds</option>
                              <option value="30">30 seconds</option>
                              <option value="35">35 seconds</option>
                              <option value="40">40 seconds</option>
                            </select>
                          </span>
                        </p>
                      </span> */}
                      <h5 style={{ marginLeft: "5px", color: "#0f0431" }}>
                        <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                          Step1
                        </b>
                        : Select the Advideo
                      </h5>
                      <div
                        ref={thumbnailParentForProduct}
                        className='thumbnails'>
                        {/* {adData?.map((item, index) => (
                          <span
                            key={index}
                            className='spanForImg'
                            onClick={(e) =>
                              selectImagehandlerForAdVideo(e, item)
                            }>
                            <img
                              className='thumbnail-img'
                              id={index}
                              src={item.thumbnail}
                              alt='ThumbImg'
                            />
                            <strong>{item.title?.slice(0, 16)}</strong>
                            <strong style={{ display: "none" }}>
                              {item._id}
                            </strong>
                          </span>
                        ))} */}



                        {adData && adData.length > 0 ? (
                          adData.map((item) => (
                            <button
                              key={item._id}
                              className="spanForImg"
                              onClick={(e) => selectImagehandlerForAdVideo(e, item)}
                              aria-label={`Select ad video: ${item.title}`}
                            >
                              <img
                                className="thumbnail-img"
                                src={item.thumbnail}
                                alt={`Thumbnail for ${item.title}`}
                              />
                              <strong>{item.title?.slice(0, 16)}</strong>
                              <strong style={{ display: "none" }}>{item._id}</strong>
                            </button>
                          ))
                        ) : (
                          <div className="no-products-message">
                            <h2>No Ad Videos at your OTT</h2>
                            <p>Check back later for new arrivals!</p>
                          </div>
                        )}


                      </div>
                      <h5 style={{ marginLeft: "5px", color: "#0f0431" }}>
                        <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                          Step2
                        </b>
                        : Click on Save button to add this to the video
                      </h5>
                      <button onClick={handleAdVideoSubmit} id='SaveBtn'>
                        <ClipLoader loading={loading} size={18} />
                        {!loading && "Save"}
                      </button>
                    </div>











                    <div ref={addpopupWindow} className='addpopupWindow'
                      style={{ minHeight: "610px", overflowY: "auto" }}

                    >
                      <span onClick={handleClosePopup} id='closeBtn'>
                        X
                      </span>
                      <span id='headContent'>
                        <p>
                          <p style={{ marginLeft: "5px", color: "#0f0431" }}>
                            <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                              Step1
                            </b>
                            : How long do you want this to be visible on the
                            Screen?
                          </p>
                          <span style={{
                            // Stack elements vertically
                          }}>
                            <p>Duration:</p>
                            <select
                              value={
                                currentEditItem?.id
                                  ? currentEditItem?.duration ?? selectedDuration
                                  : selectedDuration
                                // currentEditItem?.id ? currentEditItem?.current_duration : selectedDuration
                              }
                              onChange={selectOptionHandler}
                              className='select'>
                              <option value="Throughout">Throughout</option>
                              <option value="15">15 seconds</option>
                              <option value="30">30 seconds</option>
                              <option value="45">45 seconds</option>
                              <option value="60">1 minute</option>
                              <option value="120">2 minutes</option>

                            </select>
                          </span>
                        </p>
                      </span>
                      <h5 style={{ marginLeft: "5px", color: "#0f0431" }}>
                        <b style={{ fontSize: "25px", color: "#3d1f98" }}>Step 2</b>:{currentEditItem?.type === "internal" ? "Product" : currentEditItem?.type === "external" ? "Edit Product" : "Select the Product"}
                      </h5>

                      {/* Radio Buttons for Internal/External */}
                      {/* {!currentEditItem?.id && <div style={{ marginBottom: "15px" }} className="ms-2">
                        <label>
                          <input
                            type="radio"
                            name="selectionType"
                            value="internal"
                            checked={selectionType === "internal"}
                            onChange={handleRadioChange}
                          />
                          Shop on OTT
                        </label>
                        <label style={{ marginLeft: "10px" }}>
                          <input
                            type="radio"
                            name="selectionType"
                            value="external"
                            checked={selectionType === "external"}
                            onChange={handleRadioChange}
                          />
                          eCommerce
                        </label>
                      </div>} */}

                      {/* Internal Product Selection */}
                      {/* Show only if it's an internal product selection */}
                      {(selectionType === "internal" || currentEditItem?.type === "internal") && (
                        <div
                          ref={thumbnailParentForProduct}
                          className="thumbnails"
                          onClick={selectImagehandlerForProduct}
                        >
                          {/* Show products if available */}
                          {productdata?.length > 0 ? (
                            productdata
                              .filter((item) => item.status) // Ensure only active products are displayed
                              .map((item) => (
                                currentEditItem?.type !== "external" && (
                                  <div
                                    key={item._id}
                                    className="spanForImg"
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        selectImagehandlerForProduct(e);
                                      }
                                    }}
                                  >
                                    <img
                                      id={item._id}
                                      src={item.image || "/placeholder-image.jpg"}
                                      alt={item.title || "Product Thumbnail"}
                                      className={`thumbnail-img ${currentEditItem?.Product_Id === item._id ? "active" : ""
                                        }`} // Keep selected product active
                                      data-title={item.title || "No Title"}
                                      data-price={item.price || "N/A"}
                                    />
                                    <strong className="product-title">
                                      {item.title?.slice(0, 16) || "No Title"}
                                    </strong>
                                    <strong className="product-price">
                                      {item.sale_price ? item.sale_price : "Price Not Available"}
                                    </strong>
                                  </div>
                                )
                              ))
                          ) : (
                            // Show message only if no product is selected
                            !currentEditItem?.id && (
                              <div className="no-products-message">
                                <h2>No products at your OTT</h2>
                                <p>Check back later for new arrivals!</p>
                              </div>
                            )
                          )}
                        </div>
                      )}




                      {/* External Product Selection - Popup */}
                      {(showPopup || currentEditItem?.type === "external") && (
                        <div
                          className="popup ms-2 p-3"
                          style={{
                            border: "1px solid black",
                            width: "95%",
                            maxHeight: "700px", // Increased height
                            overflowY: "auto",
                            scrollbarWidth: "thin", // For Firefox
                            scrollbarColor: "#3d1f98 #f1f1f1", // For Firefox
                          }}
                        >
                          <div className="popupContent">
                            <h4 className="mb-2">eCommerce Product</h4>
                            {/* Product Name */}
                            <div style={{ marginBottom: "15px" }}>
                              <label>
                                Product Name: <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                value={extProductName}
                                onChange={(e) => handleFieldChange("name", e.target.value)}
                                maxLength={20}
                                placeholder="Enter product name (max 20 chars)"
                                style={{ width: "100%", padding: "5px", marginTop: "5px" }}
                              />
                              <span style={{ fontSize: "12px", color: "gray" }}>
                                {20 - extProductName.length} characters remaining
                              </span>
                            </div>

                            {/* Description */}
                            <div style={{ marginBottom: "15px" }}>
                              <label>
                                Description: <span>(optional, max 175 chars)</span>
                              </label>
                              <textarea
                                value={extProductDescription}
                                onChange={(e) => handleFieldChange("description", e.target.value)}
                                maxLength={175}
                                placeholder="Enter product description (max 175 chars)"
                                rows={3}
                                style={{
                                  width: "100%",
                                  padding: "5px",
                                  marginTop: "5px",
                                  resize: "none",
                                }}
                              />
                              <span style={{ fontSize: "12px", color: "gray" }}>
                                {175 - extProductDescription.length} characters remaining
                              </span>
                            </div>







                            {/* Price */}
                            <div style={{ marginBottom: "15px" }}>
                              <label>
                                Price: <span>(optional, max 13 chars)</span>
                              </label>
                              <input
                                type="text"
                                value={extProductPrice}
                                onChange={(e) => handleFieldChange("price", e.target.value)}
                                maxLength={13}
                                placeholder="Enter price (max 13 chars)"
                                style={{ width: "100%", padding: "5px", marginTop: "5px" }}
                              />
                              <span style={{ fontSize: "12px", color: "gray" }}>
                                {13 - extProductPrice.length} characters remaining
                              </span>
                            </div>
                            {/* Thumbnail Upload */}
                            <div style={{ marginBottom: "25px" }}>
                              <label>
                                Upload Thumbnail: <span>(320x180 px)</span>
                                <span className="text-danger"> *</span>
                              </label>
                              <div className="m-2">
                                <input type="file" onChange={handleFileUpload} />
                              </div>
                              {previewUrl && (
                                <img
                                  src={previewUrl}
                                  alt="Uploaded Thumbnail"
                                  style={{
                                    marginTop: "20px",
                                    width: "100px",
                                  }}
                                />
                              )}
                            </div>




                            {/* URL */}
                            <div style={{ marginBottom: "15px" }}>
                              <label>
                                Enter URL: <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                value={url}
                                onChange={handleUrlChange}
                                placeholder="Enter product URL"
                                style={{ width: "100%", padding: "5px", marginTop: "5px" }}
                              />
                              {urlError && (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginLeft: "10px",
                                  }}
                                >
                                  {urlError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                      )}
                      <div>
                        <h5 style={{ marginLeft: "5px", color: "#0f0431" }}>
                          <b style={{ fontSize: "25px", color: "#3d1f98" }}>Step3</b>
                          :  Name you want to show on the website
                        </h5>
                        <div className="ms-3">
                          <label>
                            Button Name:{" "}  <span className="text-danger">
                              *                                </span>
                            <input
                              type="text"
                              value={BtnName}
                              maxLength="20"
                              onChange={handleButtonNameChange}
                              required

                              placeholder="Enter Button Name"

                            />
                            {BtnName && <small> Characters remaining: {20 - BtnName?.length}
                            </small>}
                          </label>


                        </div>



                      </div>


                      <h5 style={{ marginLeft: "5px", color: "#0f0431" }}>
                        <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                          Step4
                        </b>
                        : Click on Save button to add this to the video
                      </h5>
                      <button
                        onClick={currentEditItem?.id ? handleProductEdit : handleProductSubmit}
                        // onClick={handleProductSubmit}
                        id="SaveBtn"
                      >
                        <ClipLoader loading={loading} size={18} />
                        {!loading ? (currentEditItem?.id ? "Save" : "Save") : null}
                      </button>

                    </div>

                    <div ref={addpopupForShowWindow} className='addpopupWindow'>
                      <span onClick={handleClosePopup} id='closeBtn'>
                        X
                      </span>
                      <span id='headContent'>
                        <p>
                          <p style={{ marginLeft: "5px", color: "#0f0431" }}>
                            <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                              Step1
                            </b>
                            : How long do you want this to be visible on the
                            Screen?
                          </p>
                          <span>
                            <h5>Select Duration</h5>
                            <select
                              value={selectedDuration}
                              onChange={selectOptionHandler}
                              className='select'>
                              <option value='5'>5 seconds</option>
                              <option value='10'>10 seconds</option>
                              <option value='15'>15 seconds</option>
                              <option value='20'>20 seconds</option>
                              <option value='25'>25 seconds</option>
                              <option value='30'>30 seconds</option>
                              <option value='35'>35 seconds</option>
                              <option value='40'>40 seconds</option>
                            </select>
                          </span>
                        </p>
                      </span>
                      <h5 style={{ marginLeft: "5px", color: "#0f0431" }}>
                        <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                          Step2
                        </b>
                        : Select the Product
                      </h5>
                      <div
                        ref={thumbnailParent}
                        className='thumbnails'
                        onClick={selectImagehandler}>
                        {productdata?.map((item, index) =>
                          item.status ? (
                            <span className='spanForImg'>
                              <img
                                className=''
                                width={80}
                                id={index}
                                src={item.image}
                                alt='ThumbImg'
                              />
                              <strong>{item.title?.slice(0, 16)}</strong>
                              <strong>{item.price}</strong>
                              <strong style={{ display: "none" }}>
                                {item._id}
                              </strong>
                            </span>
                          ) : null
                        )}
                      </div>
                      <h5 style={{ margin: "10px", color: "#0f0431" }}>
                        <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                          Step3
                        </b>
                        : Add URL{" "}
                        <input
                          type='text'
                          onChange={handleInputChange}
                          id='inputBoxInShow'
                        />
                      </h5>

                      <h5 style={{ marginLeft: "5px", color: "#0f0431" }}>
                        <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                          {" "}
                          Step4
                        </b>
                        : Click on Save button to add this to the video
                      </h5>
                      <button onClick={handleSubmitShopData} id='SaveBtn'>
                        <ClipLoader loading={loading} size={18} />
                        {!loading && "Save"}
                      </button>
                    </div>
                    <div
                      ref={addpopupForShowScanBuy}
                      className='addpopupWindow'>
                      <span onClick={handleClosePopup} id='closeBtn'>
                        X
                      </span>
                      <span id='headContent'>
                        <p>
                          <h5 style={{ marginLeft: "5px", color: "#0f0431" }}>
                            <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                              Step1
                            </b>
                            : How long do you want this to be visible on the
                            Screen?
                          </h5>
                          <span>
                            <h5>Select duration</h5>
                            <select
                              value={selectedDuration}
                              onChange={selectOptionHandler}
                              className='select'>
                              {/* <option value='5'>5 seconds</option>
                              <option value='10'>10 seconds</option>
                              <option value='15'>15 seconds</option>
                              <option value='20'>20 seconds</option>
                              <option value='25'>25 seconds</option>
                              <option value='30'>30 seconds</option>
                              <option value='35'>35 seconds</option>
                              <option value='40'>40 seconds</option> */}
                              <option value="15">15 seconds</option>
                              <option value="30">30 seconds</option>
                              <option value="45">45 seconds</option>
                              <option value="60">1 minute</option>
                              <option value="120">2 minutes</option>
                            </select>

                          </span>
                        </p>
                      </span>
                      <h5 style={{ marginLeft: "5px", color: "#0f0431" }}>
                        <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                          Step2
                        </b>
                        : Select the Product
                      </h5>
                      <div
                        ref={thumbnailParentForScan}
                        className='thumbnails'
                        onClick={selectImagehandlerForScan}>
                        {productdata?.map((item, index) =>
                          item.status ? (
                            <span className='spanForImg'>
                              <img
                                className=''
                                width={80}
                                id={index}
                                src={item.image}
                                alt='ThumbImg'
                              />
                              <strong>{item.title?.slice(0, 16)}</strong>
                              <strong>{item.price}</strong>
                              <strong style={{ display: "none" }}>
                                {item._id}
                              </strong>
                            </span>
                          ) : null
                        )}
                      </div>
                      <h5 style={{ margin: "10px", color: "#0f0431" }}>
                        <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                          Step3
                        </b>
                        : Add URL{" "}
                        <input
                          type='text'
                          onChange={handleInputChangeForQrCode}
                          id='inputBoxInShow'
                        />
                      </h5>

                      <h5 style={{ marginLeft: "5px", color: "#0f0431" }}>
                        <b style={{ fontSize: "25px", color: "#3d1f98" }}>
                          {" "}
                          Step4
                        </b>
                        : Click on Save button to add this to the video
                      </h5>
                      <button onClick={handleSubmitScanToBuy} id='SaveBtn'>
                        {" "}
                        <ClipLoader loading={loading} size={18} />
                        {!loading && "Save"}
                      </button>
                    </div>
                    {videos?.video ? (
                      <>
                        <JPlayer
                          id={defaultOptions.id}
                          className='jp-sleek JPContainer'>
                          <div className='jp-media-container allVideos'>
                            <Video onLoadedMetadata={handleLoadedMetadata} />

                            <div
                              ref={addProdRef}
                              onClick={handleAddproduct}
                              className='addProduct'>
                              Shop on device
                            </div>
                            {/* <div ref={shopNowRef} onClick={handleShop} className="shopNow">
                              Shop on websitehhhhhhhhhh
                            </div> */}
                            <div
                              ref={adVideoRef}
                              onClick={handleAdVideo}
                              className='shopNow'>
                              Insert Ad Video
                            </div>
                            {/* <div
                              ref={viewMoreRef}
                              onClick={handleViewMore}
                              className='viewMore'>
                              Scan to Buy
                            </div> */}
                            {/* <div
                              ref={QrCodeRef}
                              onClick={handleQrCode}
                              className='QrCode'>
                              Add QR code
                            </div> */}
                          </div>
                          <Gui>
                            <div className='jp-controls jp-icon-controls controller'>
                              <Play>
                                <i
                                  onClick={handlePlayClick}
                                  className='fa fa-play'></i>
                              </Play>
                              <div className='jp-progress'>
                                <SeekBar>
                                  <BufferBar />
                                  <PlayBar />
                                  <CurrentTime />
                                  <Duration />
                                </SeekBar>
                              </div>
                              <div className='jp-volume-container'>
                                <Mute>
                                  <i className='fas fa-volume-mute'></i>
                                </Mute>
                                <div className='jp-volume-slider'>
                                  <div className='jp-volume-bar-container'>
                                    <VolumeBar />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <BrowserUnsupported />
                          </Gui>
                        </JPlayer>
                      </>
                    ) : (
                      <div className='loader'>
                        <Loader
                          type='Grid'
                          color='#0d6efd'
                          height={100}
                          width={100}
                        />
                      </div>
                    )}

                    {studioDataLoading ? (
                      <div className="text-center py-4">
                        <div className="spinner-border text-primary mb-2" role="status"></div>
                        <p className="text-muted mb-0">Loading advertising data...</p>
                      </div>
                    ) : (
                      <div className="table-responsive bg-white shadow-sm rounded  ">
                        <table className="table table-hover align-middle mb-0">
                          <thead className="bg-primary text-white">
                            <tr className="text-center">
                              <th style={{ width: "120px" }}>Product</th>
                              <th>CTA</th>
                              <th>Type</th>
                              <th>Current Time</th>
                              <th>Duration</th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {resData?.items?.length > 0 ? (
                              resData.items.map((item, index) => (
                                <tr key={index} className={index % 2 === 0 ? "bg-light" : ""}>
                                  <td className="text-center">
                                    <img
                                      alt="product"
                                      src={
                                        item.product?.image ||
                                        item.AdVideo?.thumbnail ||
                                        item?.extProductThumbnail_Url
                                      }
                                      className="rounded shadow-sm"
                                      style={{
                                        width: "70px",
                                        height: "auto",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </td>

                                  <td className="text-center text-capitalize">
                                    {item?.CTA === "undefined" ? "Shop on Device" : item?.CTA}
                                  </td>

                                  <td className="text-center">
                                    {item?.type === "external"
                                      ? "eCommerce"
                                      : item?.type === "video"
                                        ? "Ad Video"
                                        : "Shop on OTT"}
                                  </td>

                                  <td className="text-center fw-semibold">
                                    {item?.current_time} sec
                                  </td>

                                  <td className="text-center">
                                    {item?.type === "video"
                                      ? `${item?.AdVideo?.duration || "N/A"} sec`
                                      : item?.duration || item?.AdVideo?.duration}
                                  </td>

                                  <td className="text-center">
                                    <div className="d-flex justify-content-center gap-2">
                                      <button
                                        ref={item?.type === "video" ? adVideoRef : addProdRef}
                                        onClick={
                                          item?.type === "video"
                                            ? () => handleAdVideo(item)
                                            : () => handleAddproduct(item)
                                        }
                                        className="btn btn-sm btn-outline-primary px-3"
                                      >
                                        <i className="bi bi-pencil-square me-1"></i> Edit
                                      </button>

                                      <button
                                        onClick={() => handleDelete(item?.id)}
                                        className="btn btn-sm btn-outline-danger px-3"
                                      >
                                        <i className="bi bi-trash me-1"></i> Delete
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="6"
                                  className="text-center py-4 text-muted fst-italic"
                                >
                                  No advertising product or video added yet.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}



                    {/* {
                                            resData?.products?.length > 0 ?
                                                <div id="span">
                                                    <div className="header">
                                                        <p>Product</p>
                                                        <div className="headerData">
                                                            {
                                                                resData?.products?.map(item => (
                                                                    <p>
                                                                        <img 
                                                                        alt=""
                                                                        id="headerImg" src={item.image} ></img>
                                                                    </p>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="header">
                                                        <p>CTA</p>
                                                        <div className="headerData">
                                                            {
                                                                resData?.CTA?.map(item => (
                                                                    <p>{item}</p>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="header">
                                                        <p>Duration</p>
                                                        <div className="headerData">
                                                            {
                                                                resData?.duration?.map(item => (
                                                                    <p>{item}</p>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="header">
                                                        <p>Product</p>
                                                        <div className="headerData">
                                                            {
                                                                resData?.products?.map(item => (
                                                                    <button onClick={() => handleDelete(item._id)} id="btn">Delete</button>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div >
  );
}

export default AddStudio;
